import { Outlet } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Analytics } from "@vercel/analytics/react"; // 👈 importa Analytics

export default function App() {
  return (
    <>
      <Navigation />
      <Outlet />
      {/* Footer global aquí si lo tienes */}
      <Analytics />  {/* Para que funcione Analytics en vercel*/}
    </>
  );
}
